// counterSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchTotalPartner = createAsyncThunk(
  'totalPartner/fetchTotalPartner',
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('admintoken');
      if (!token) {
        throw new Error('Authorization token not found');
      }
      const response = await axios.post(
        'https://onboard.rechargkit.biz/home/totalPartner',
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const totalPartnerSlice = createSlice({
  name: 'totalPartner',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTotalPartner.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTotalPartner.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchTotalPartner.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default totalPartnerSlice.reducer;
